import { render, staticRenderFns } from "./AttendanceSso.vue?vue&type=template&id=8ef4ad16"
import script from "./AttendanceSso.vue?vue&type=script&lang=js"
export * from "./AttendanceSso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports